export default __webpack_public_path__ + "c3392e210a5537b743b869b4415ac7a3.svg";